export const create = {
  createSuccessfully: 'Create new tank history successfully!',
}
